<template>
	<div>
		<van-tabs v-model="active" title-active-color="#0ec9ac" color="#0ec9ac">
			<van-tab title="科室介绍" style="margin-top: 10px;">
				<div class="div_hh">
					<van-cell-group :border="false" class="m-t-20">
						<van-cell title="科室名称" :value="deptInfo.name" />
						<van-cell v-if="deptInfo.linkman" title="科室联系人" :value="deptInfo.linkman" />
						<van-cell v-if="deptInfo.linkphone" title="科室联系电话" :value="deptInfo.linkphone" />
						<van-cell center title="科室摘要" v-if="deptInfo.summary">
							<template #title>
								<span style="font-weight: bold;">科室摘要</span>
							</template>
							<template #label>
								<div>{{ deptInfo.summary }}</div>
							</template>
						</van-cell>

						<van-cell center title="科室介绍" v-if="deptInfo.profile">
							<template #title>
								<span style="font-weight: bold;">科室介绍</span>
							</template>
							<template #label>
								<div v-html="deptInfo.profile"></div>
							</template>
						</van-cell>
					</van-cell-group>
				</div>
			</van-tab>
			<van-tab title="专家列表" style="margin-top: 10px;">
				<div class="div_hh">
					<div v-for="(d, index) of doctorList" :key="index" class="div_back_color">
						<div style="display: flex;">
							<div style="width: 25%;padding:10px;">
								<!-- 图片 -->
								<div class="doctor_image">
									<van-image v-if="d.headpic" width="50" height="50" fit="cover" :src="img_prefix + d.headpic" />
									<van-image v-else width="50" height="50" fit="cover" :src="doctorNoImg" />
								</div>
							</div>
							<div style="width: 75%;padding: 20px 10px;" @click="toDetail(d)">
								<!-- 医生姓名和职称 -->
								<van-row>
									<van-col span="6">
										<span style="font-weight: bold;">{{ d.name }}</span>
									</van-col>
									<van-col span="18">
										<span style="font-size: 14px;color: gray;">{{ d.professional }}</span>
									</van-col>
								</van-row>
								<van-row style="padding-top: 10px;">
									<van-col span="20">
										<div class="doctot_sc">擅长：{{ d.goodAt }}</div>
									</van-col>
									<van-col span="4">
										<div style="float: right;"><van-icon slot="right-icon" name="arrow" size="22px" color="grey" /></div>
									</van-col>
								</van-row>
							</div>
						</div>
					</div>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
import { getDoctorIndex, getDeptDetail } from '@/api/hdTCM';
export default {
	components: {},
	data() {
		return {
			active: 0, //默认展示科室介绍tab
			doctorList: [], //科室下专家信息
			deptInfo: '', //科室介绍信息
			doctorNoImg: require('@assets/images/guanzys.png'),
			img_prefix: process.env.VUE_APP_IMG_BASEURL //专家医生的图片前缀
		};
	},

	created() {
		getDoctorIndex({ departCode: this.$route.query.code }).then(res => {
			if (res.success) {
				this.doctorList = res.result;
			}
		});
		getDeptDetail({ code: this.$route.query.code }).then(res => {
			if (res.success) {
				this.deptInfo = res.result;
			}
		});
	},

	methods: {
		toDetail(v) {
			this.$router.push({ path: '/doctor_detail', query: { id: v.code } });
		}
	}
};
</script>

<style scoped>
.doctor_image {
	width: 60px;
	height: 60px;
	border: 1px solid gainsboro;
	border-radius: 50%;
	text-align: center;
	padding: 10px;
}
.doctot_sc {
	font-size: 14px;
	color: grey;
	height: 40px;
	overflow-y: auto;
	overflow-x: hidden;
}
.div_hh {
	overflow-y: auto;
	overflow-x: hidden;
	position: fixed;
	height: 90%;
	width: 100%;
}
.div_back_color {
	background-color: white;
	border-bottom: 1px solid gainsboro;
}
</style>
